<template>
    <div :class="classes">
        <el-dropdown>
            <span class="el-dropdown-link">
                <div>{{ this.user.name }}</div>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="getuser">账号信息</el-dropdown-item>
                <el-dropdown-item @click.native="out">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
<script>
const prefix = "w-user";

export default {
    props: {},
    data() {
        return {
            user: {},
            options: [
                {
                    label: "",
                },
            ],
        };
    },
    methods: {
        init() {
            this.getuserinfo();
        },
        async out() {
            await this.$confirm("确认退出？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                type: "",
                center: true,
            });

            let data = await this.api.logout({
                access_token: localStorage.getItem("access_token"),
            });

            if (data.result == 0) {
                window.location.href = data.data;
            }
        },
        getuserinfo() {
            this.api
                .selfInfo({
                    access_token: localStorage.getItem("access_token"),
                })
                .then((da) => {
                    this.user = da;
                });
        },
        getuser() {
            this.router.push({
                path: "/userinfo/user",
                query: {
                    info: JSON.stringify(this.user),
                },
            });
        },
    },
    created() {
        this.init();
    },
    computed: {
        classes() {
            return [prefix];
        },
    },
};
</script>

<style lang="scss">
$prefixCls: w-user;

.#{$prefixCls} {
    cursor: pointer;
    .el-dropdown-link{
        color: #333;
    }
}
</style>
